module.exports = __webpack_public_path__ + "assets/img/slow_cook.052c8a8a.png";